import { generateClient } from "aws-amplify/api";

// gql
import { gqlQueryListOpenJobService } from '../../graphql/query.list.open.job.services';

// client
const gqlclient = generateClient();

const getData = async ({ next_token = null }) => {
  // query
  const res = await gqlclient.graphql({
    query: gqlQueryListOpenJobService,
    variables: {
      next_token: next_token
    }
  });
  console.log('services.job.query.open.job.services@getData', 'res', res);
  const { errors, data } = res;

  // error?
  if (errors) {
    const error = errors[0];
    throw Error(error.message);
  }

  return data.listOpenJobService;
}

async function handler({ next_token = null }, { getState, rejectWithValue }) {
  try {
    console.log('services.job.query.open.job.services@handler', 'Invoked');

    const res = await getData({
      next_token: next_token,
    });
    console.log('services.job.query.open.job.services@handler', 'res', res);

    return res;

  } catch (error) {
    console.error('services.job.query.open.job.services@handler', error);
    return rejectWithValue(error);
  }
}

function pending(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function fulfilled(state, action) {
  console.log('services.job.query.open.job.services@fulfilled', 'action', action.payload, state.items.length);
  return {
    ...state,
    loading: false,
    items: state.items.length === 0
      ? action.payload.items
      : [...state.items, ...action.payload.items],
    next_token: action.payload.nextToken,
    is_first_loading: false,
  };
}

function rejected(state, action) {
  return {
    ...state,
    loading: false,
    is_first_loading: true,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}